import React, { useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import CaptchaImage, { generateCaptcha } from "../../globalUtilities/captcha";
import { Button } from "primereact/button";
import { validateEmail } from "../../globalUtilities/validation";
import { Toast } from "primereact/toast";
import { passwordReset } from "../../services/auth/login";

const StepFour = ({
  email,
  setEmail,
  error,
  enteredCaptcha,
  setEnteredCaptcha,
  captcha,
  setStep,
  handleBackToLogin,
  setCaptcha,
}) => {
  const [emailErr, setEmailErr] = useState("");
  const [captchaErr, setCaptchaErr] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const toast = useRef(null);

  const showError = (message) => {
    toast.current.show({
      severity: "error",
      summary: "Error",
      detail: message,
      life: 3000,
    });
  };

  const handleSubmitClick = () => {
    if (!validateEmail(email)) {
      setEmailErr("Please enter a valid email address.");
    } else if (enteredCaptcha !== captcha) {
      setCaptchaErr("Invalid captcha. Please try again.");
      setCaptcha(generateCaptcha()); // Regenerate captcha if invalid
      setEnteredCaptcha(""); // Clear the entered captcha field
    } else {
      setEmailErr("");
      setCaptchaErr("");
      setIsSubmitting(true);

      passwordReset({ email })
        .then((response) => {
          if (response?.data?.message) {
            toast.current.show({
              severity: "success",
              summary: "Success",
              detail: response?.data?.message,
              life: 3000,
            });
            setIsSubmitting(false);
            setCaptcha(generateCaptcha()); // Regenerate captcha if invalid
            setEnteredCaptcha(""); // Clear the entered captcha field
          } else {
            console.error("There is some issue in email link sending");
            setIsSubmitting(false);
          }
        })
        .catch((error) => {
          setIsSubmitting(false);
          showError(error?.response?.data?.message);
        });
    }
  };

  return (
    <>
      <Toast ref={toast} />
      {/* Desktop View Start */}
      <div className="read-terms fw-600" style={{ fontSize: "large" }}>
        Reset Password
      </div>
      <div className="login-form-pad-desktop-step-2 d-none d-md-block">
        <div className="d-flex align-items-center">
          <span className="pi pi-envelope me-2 text-secondary"></span>
          <InputText
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter Email Address"
            className="username w-100"
          />
        </div>
        {emailErr && (
          <div className="error-message text-danger align-items-left fs-error">
            {emailErr}
          </div>
        )}
        <div className="mt-4 d-flex align-items-center">
          <span className="pi pi-lock me-2 text-secondary"></span>
          <InputText
            value={enteredCaptcha}
            onChange={(e) => setEnteredCaptcha(e.target.value)}
            placeholder="Enter security code"
            className="username w-100"
          />
        </div>
        {captchaErr && (
          <div className="error-message text-danger align-items-left fs-error">
            {captchaErr}
          </div>
        )}
        <div className="captcha-display">
          <CaptchaImage captcha={captcha} />
        </div>
        <div className="text-center pt-1 mt-4 pb-1">
          <Button
            label="SUBMIT"
            onClick={handleSubmitClick}
            loading={isSubmitting}
            className="mb-4 w-100 fw-600 next-button"
          />
        </div>
        <div>
          <span className="forgot-password" onClick={() => handleBackToLogin()}>
            Go Back to Login
          </span>
        </div>
      </div>
      {/* Desktop View End */}
      {/* Mobile View Start */}
      <div className="login-form-pad-mobile-step-2 d-block d-md-none">
        <div className="d-flex align-items-center">
          <span className="pi pi-envelope me-2 text-secondary"></span>
          <InputText
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter Email Address"
            className="username w-100"
          />
        </div>
        {error && (
          <div className="error-message text-danger align-items-left fs-error">
            {error}
          </div>
        )}
        <div className="mt-4 d-flex align-items-center">
          <span className="pi pi-lock me-2 text-secondary"></span>
          <InputText
            autoFocus
            value={enteredCaptcha}
            onChange={(e) => setEnteredCaptcha(e.target.value)}
            placeholder="Enter security code"
            className="username w-100"
          />
        </div>
        {error && (
          <div className="error-message text-danger align-items-left fs-error">
            {error}
          </div>
        )}
        <div className="captcha-display">
          <CaptchaImage captcha={captcha} />
        </div>
        <div className="text-center pt-1 mt-4 pb-1">
          <Button
            label="SUBMIT"
            onClick={handleSubmitClick}
            loading={isSubmitting}
            className="mb-4 w-100 next-button"
          />
        </div>
        <div>
          <span className="forgot-password" onClick={() => handleBackToLogin()}>
            Go Back to Login
          </span>
        </div>
      </div>
      {/* Mobile View End */}
    </>
  );
};

export default StepFour;
